import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import A from '@adsk/alloy-react-a';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import getPhotoUrl from './helpers/getPhotoUrl';

const StyledReferencesPlaceholder = styled.div({
  ...theme.typography.bodyLarge,
  textAlign: 'center',
  paddingTop: 24,
});

const PhotoReferencesPlaceholder = ({ projectId, photoUid }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const photoUrl = getPhotoUrl(projectId, photoUid);
  return (
    <StyledReferencesPlaceholder>
      {T.translate('VIEW_REFERENCES_IN_PHOTOS_TOOL', {
        photosToolLink: (
          <A href={photoUrl} target="_blank">
            {T.translate('PHOTOS_TOOL')}
          </A>
        ),
      })}
    </StyledReferencesPlaceholder>
  );
};

PhotoReferencesPlaceholder.propTypes = {
  projectId: PropTypes.string,
  photoUid: PropTypes.string,
};

export default PhotoReferencesPlaceholder;
